<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="record.status !== 'approved'" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div v-if="record.author">Автор: {{ record.author.fullName }}</div>
      <div v-if="record.approver">Проверяющий: {{ record.approver.fullName }}</div>
      <n-button v-if="edit.author" @click="$var('toApprove', true)">На проверку</n-button>
      <n-button v-if="edit.approver" @click="$var('approve', true)">Проверено</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="Краткое описание строительно-монтажных работ, их месторасположение" v-bind="$form.input('description')" :text="!edit.author" />
      <n-input title="Состояние погоды и температура наружного воздуха" v-bind="$form.input('weather')" :text="!edit.author" />
      <n-input title="Принимаемые меры в особых условиях (зимний период, жара и т.д.)" v-bind="$form.input('solution')" :text="!edit.author" />
      <n-input title="Результаты операционного контроля качества работ" v-bind="$form.input('results')" :text="!edit.approver" />

      <!-- Files -->
      <template v-for="(array, name) in files">
        <n-form-item v-if="$n.size(array)" :key="name" :title="translates[name]" active>
          <div v-for="doc in array" :key="doc.id">
            <n-link :to="doc.file.src" type="external" target="_blank">{{ doc.file.name }}</n-link>
          </div>
        </n-form-item>
      </template>
      <!-- Files -->

      <n-form-item v-if="$n.size(record.work)" title="Работа" active>
        {{ record.work.title }}, {{ record.work.recordDone }}
        <span class="sub">{{ record.work.unit }}</span>
      </n-form-item>

      <n-form-item v-if="$n.size(record.supplies)" title="Материалы" active>
        <n-table class="table" :columns="columns" :data="record.supplies">
          <template #done="{item}">
            <span style="white-space: nowrap">
              {{ item.recordDone }}
              <span class="sub">{{ item.unit }}</span>
            </span>
          </template>
        </n-table>
      </n-form-item>
    </n-items>

    <br />
    <n-divide>
      <n-button color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>

    <c-modal-journal-do-sign v-if="$var('toApprove')" :data="record" @close="$var('toApprove', false)" @submit="toApprove" />
    <c-modal-journal-do-sign v-if="$var('approve')" :data="record" @close="$var('approve', false)" @submit="approve" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: {},
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        author: this.record.status === 'formed' && this.record.authorId === $app.auth.user().id,
        approver: this.record.status === 'approving' && $app.auth.can('journals_main_approver', this.project.id),
      }
    },
    files() {
      const result = {
        attach: [],
        schema: [],
        figure: [],
        input: [],
      }
      
      if (this.record.documents) {
        this.record.documents.forEach((item) => {
          if ([ 'attach', 'schema', ].includes(item.code)) {
            result[item.code].push(item)
          } else if (item.code === 'input-34') {
            result.input.push(item)
          } else {
            result.figure.push(item)
          }
        })
      }
      
      return result
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[approver][with][participation]': null,
        'with[documents][with][file]': null,
        'with[work]': null,
        'with[supplies]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.record.work = this.record.work[0]
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    toApprove(sign) {
      this.$var('load', true)
      $api.journals.main.records.toApprove(this.record.id, { sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    approve(sign) {
      this.$var('load', true)
      const data = {
        ...this.$form.get(),
        sign,
      }
      $api.journals.main.records.approve(this.record.id, data).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.main.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
